setTimeout(function() {
	$('#form341').validate({
		rules: {
			Field9: { valueNotEquals: "default" }
		},
		messages: {
			SelectName: { valueNotEquals: "Please select an item!" }
		}
	});

	$.validator.addMethod("valueNotEquals", function(value, element, arg){
		return arg !== value;
	}, "Please select a topic.");

	if (window.location.href.indexOf('thanks') > -1) {
		$('#form341').hide();
		$('#thanks').show();
	}

}, 2000);
